import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";
import { useTranslation } from "react-i18next";
import Sidebar from "../components/Sidebar";
import Reveal from "../components/Reveal";
import logo from "../assets/images/logo.png";
import LanguageSwitcher from "../components/LanguageSwitcher";
import image17 from "../assets/images/image17.jpg";

const ComingSoon = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div
      style={{
        backgroundImage: `url(${image17})`,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        backgroundBlendMode: "darken",
      }}
      className="relative min-h-screen bg-cover bg-center flex flex-col"
    >
      <div className="absolute top-0 left-0 right-0 z-30 flex items-center h-[64px] sm:h-[72px] md:h-[82px]">
        <div
          className="relative h-full w-full mx-auto px-4 sm:px-6 flex items-center justify-between"
          style={{ maxWidth: "1320px" }}
        >
          <button
            onClick={() => setSidebarOpen(true)}
            aria-label={t("nav.openMenu")}
            className="flex flex-col gap-[4px] sm:gap-[5px] group"
          >
            <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-white group-hover:opacity-70 transition-opacity duration-200" />
            <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-white group-hover:opacity-70 transition-opacity duration-200" />
            <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-white group-hover:opacity-70 transition-opacity duration-200" />
          </button>

          <div className="flex justify-center items-center gap-2 sm:gap-3">
            <img src={logo} alt="" className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20" />
            <Link
              to="/"
              className="text-white text-sm sm:text-base md:text-xl font-bold uppercase tracking-wider sm:tracking-widest hover:opacity-70 transition-opacity duration-200"
            >
              {t("header.brand")}
            </Link>
          </div>
          <LanguageSwitcher className="text-white" />
        </div>
      </div>

      <div className="relative z-10 flex-1 flex items-center justify-center px-4 py-24">
        <div className="max-w-2xl text-center text-white">
          <Reveal direction="up" className="flex justify-center mb-6">
            <Construction size={56} className="text-yellow-500" />
          </Reveal>
          <Reveal
            as="p"
            direction="up"
            delay={0.15}
            className="text-sm sm:text-base uppercase tracking-[0.3em] text-yellow-500 mb-4"
          >
            {t("comingSoon.kicker")}
          </Reveal>
          <Reveal
            as="h1"
            direction="up"
            delay={0.3}
            className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-widest mb-5"
          >
            {t("comingSoon.title")}
          </Reveal>
          <Reveal
            as="p"
            direction="up"
            delay={0.45}
            className="text-lg sm:text-xl font-semibold italic text-slate-200 mb-4"
          >
            {t("comingSoon.subtitle")}
          </Reveal>
          <Reveal
            as="p"
            direction="up"
            delay={0.6}
            className="text-sm sm:text-base text-gray-300 leading-relaxed mb-10"
          >
            {t("comingSoon.body")}
          </Reveal>
          <Reveal direction="up" delay={0.75} className="flex justify-center">
            <Link
              to="/"
              className="group inline-flex items-center gap-3 border border-white px-6 py-3 text-sm font-semibold uppercase tracking-widest text-white hover:bg-white hover:text-[#223746] transition-colors duration-200"
            >
              <ArrowLeft
                size={18}
                className="transition-transform duration-200 group-hover:-translate-x-1"
              />
              {t("comingSoon.backHome")}
            </Link>
          </Reveal>
        </div>
      </div>

      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
    </div>
  );
};

export default ComingSoon;
